// Multi-language knitting dictionary
// Supported: de (German), it (Italian), fr (French), es (Spanish)

window.translatorDicts = {
  // ============================================================
  // GERMAN (Original)
  // ============================================================
  de: {
    simple: {
      // === BASIC STITCHES ===
      "k": "re",
      "p": "li",
      "knit": "rechts stricken",
      "purl": "links stricken",
      "yo": "Umschlag",
      "sl": "abh.",
      "slip": "abheben",
      "st": "M",
      "sts": "M",
      "stitch": "Masche",
      "stitches": "Maschen",

      // === CAST ON METHODS ===
      "cast on": "anschlagen",
      "co": "anschlagen",
      "long tail cast on": "Kreuzanschlag",
      "cable cast on": "Maschen mit Nadel anschlagen",
      "knitted cast on": "gestrickter Anschlag",
      "provisional cast on": "provisorischer Anschlag",
      "tubular cast on": "italienischer Anschlag",
      "italian cast on": "italienischer Anschlag",
      "judy's magic cast on": "Judy's magischer Anschlag",
      "jmco": "Judy's magischer Anschlag",
      "backwards loop cast on": "Rückwärtsschleifen-Anschlag",
      "backward loop cast on": "Rückwärtsschleifen-Anschlag",
      "german twisted cast on": "altdeutscher Anschlag",
      "old norwegian cast on": "altdeutscher Anschlag",
      "crochet cast on": "gehäkelter Anschlag",
      "emily ocker's cast on": "Emily Ockers Anschlag",
      "turkish cast on": "türkischer Anschlag",
      "figure 8 cast on": "Achter-Anschlag",

      // === BIND OFF METHODS ===
      "bind off": "abketten",
      "bo": "abketten",
      "cast off": "abketten",
      "stretchy bind off": "elastisches Abketten",
      "sewn bind off": "genähtes Abketten",
      "three needle bind off": "Abketten mit 3 Nadeln",
      "3 needle bind off": "Abketten mit 3 Nadeln",
      "picot bind off": "Picot-Abketten",
      "i-cord bind off": "I-Kordel-Abketten",
      "icord bind off": "I-Kordel-Abketten",
      "tubular bind off": "italienisches Abketten",
      "italian bind off": "italienisches Abketten",
      "suspended bind off": "verzögertes Abketten",
      "jeny's surprisingly stretchy bind off": "Jenys elastisches Abketten",
      "jssbo": "Jenys elastisches Abketten",

      // === ROWS AND ROUNDS ===
      "row": "Reihe",
      "rows": "Reihen",
      "round": "Runde",
      "rnd": "Runde",
      "rounds": "Runden",
      "rnds": "Runden",
      "rs": "rechte Seite",
      "ws": "linke Seite",
      "right side": "rechte Seite",
      "wrong side": "linke Seite",
      "in the round": "in Runden",
      "worked flat": "flach gestrickt",
      "back and forth": "hin und zurück",
      "bor": "Rundenanfang",
      "beginning of round": "Rundenanfang",
      "end of round": "Rundenende",

      // === BASIC INSTRUCTIONS ===
      "repeat": "wiederholen",
      "rep": "wdh.",
      "until": "bis",
      "from": "von",
      "to end": "bis zum Ende",
      "to last": "bis zu den letzten",
      "across": "über die gesamte Reihe",
      "work even": "ohne Zunahmen/Abnahmen arbeiten",
      "continue": "fortfahren",
      "continue in pattern": "im Muster fortfahren",
      "at the same time": "gleichzeitig",
      "every other row": "jede 2. Reihe",
      "every 4th row": "jede 4. Reihe",
      "times": "mal",
      "times more": "mal mehr",
      "remaining": "übrig",
      "rem": "übrig",

      // === INCREASES (SIMPLE) ===
      "increase": "zunehmen",
      "inc": "zun.",
      "kfb": "re in vord. u. hint. MG",
      "pfb": "li in vord. u. hint. MG",
      "m1": "1 M zun.",
      "make one": "1 Masche zunehmen",

      // === DECREASES (SIMPLE) ===
      "decrease": "abnehmen",
      "dec": "abn.",
      "p2tog": "2 M li zus.",
      "p3tog": "3 M li zus.",
      "skp": "1 M abh., 1 M re, abgeh. M überz.",
      "psso": "abgeh. M überziehen",
      "pass slipped stitch over": "abgehobene Masche überziehen",

      // === STITCH PATTERNS ===
      "stockinette": "glatt rechts",
      "stockinette stitch": "glatt rechts",
      "st st": "glatt rechts",
      "stocking stitch": "glatt rechts",
      "reverse stockinette": "glatt links",
      "reverse st st": "glatt links",
      "rev st st": "glatt links",
      "garter": "kraus rechts",
      "garter stitch": "kraus rechts",
      "ribbing": "Bündchen",
      "rib": "Rippe",
      "1x1 rib": "1 re, 1 li Rippe",
      "2x2 rib": "2 re, 2 li Rippe",
      "seed stitch": "Perlmuster",
      "moss stitch": "großes Perlmuster",
      "basketweave": "Flechtmuster",
      "honeycomb": "Wabenmuster",
      "trinity stitch": "Dreifältigkeitsmuster",
      "blackberry stitch": "Brombeermuster",
      "bobble": "Noppe",
      "popcorn stitch": "Popcorn-Masche",
      "lace": "Lochmuster",
      "eyelet": "Loch",
      "faggoting": "Durchbruchmuster",
      "nupps": "Nüppchen",
      "beaded": "mit Perlen",

      // === CABLES ===
      "cable": "Zopfmuster",
      "cn": "Zopfnadel",
      "cable needle": "Zopfnadel",
      "twist": "Verschränkung",
      "hold in front": "vor der Arbeit halten",
      "hold in back": "hinter der Arbeit halten",
      "cross": "kreuzen",

      // === COLORWORK ===
      "mc": "Hauptfarbe",
      "main color": "Hauptfarbe",
      "cc": "Kontrastfarbe",
      "contrast color": "Kontrastfarbe",
      "color a": "Farbe A",
      "color b": "Farbe B",
      "color c": "Farbe C",
      "stranded": "Jacquard",
      "stranded colorwork": "Jacquard",
      "fair isle": "Fair Isle",
      "intarsia": "Intarsien",
      "mosaic knitting": "Mosaikstricken",
      "double knitting": "Doubleface",
      "float": "Spannfaden",
      "catch float": "Spannfaden einfangen",
      "steek": "Steek",
      "dominant color": "dominante Farbe",

      // === SHORT ROWS ===
      "short rows": "verkürzte Reihen",
      "turn": "wenden",
      "wrap and turn": "umwickeln und wenden",
      "w&t": "umwickeln und wenden",
      "w+t": "umwickeln und wenden",
      "pick up wrap": "Wicklung aufnehmen",
      "hide wrap": "Wicklung verstecken",
      "shadow wrap": "Schattenwicklung",
      "twin stitch": "Zwillingsmasche",

      // === NEEDLES ===
      "dpn": "Nadelspiel",
      "dpns": "Nadelspiel",
      "double pointed needles": "Nadelspiel",
      "circular needle": "Rundstricknadel",
      "circulars": "Rundstricknadeln",
      "straight needles": "gerade Nadeln",
      "interchangeable": "Wechselsystem",
      "cable length": "Seillänge",

      // === TECHNIQUES ===
      "join": "verbinden",
      "join for working in the round": "zur Runde schließen",
      "place marker": "Markierer setzen",
      "pm": "Markierer setzen",
      "slip marker": "Markierer abheben",
      "sm": "Markierer abheben",
      "marker": "Markierer",
      "pick up": "aufnehmen",
      "pick up and knit": "aufnehmen und rechts stricken",
      "pick up and purl": "aufnehmen und links stricken",
      "knitwise": "wie zum Rechtsstricken",
      "purlwise": "wie zum Linksstricken",
      "tbl": "verschränkt",
      "through back loop": "ins hintere Maschenglied",
      "wyib": "Faden hinter der Arbeit",
      "wyif": "Faden vor der Arbeit",
      "with yarn in back": "Faden hinter der Arbeit",
      "with yarn in front": "Faden vor der Arbeit",
      "hold": "stilllegen",
      "place on holder": "auf Maschenhalter legen",
      "set aside": "beiseitelegen",
      "break yarn": "Faden abschneiden",
      "join yarn": "Faden neu ansetzen",

      // === GARMENT PARTS ===
      "sleeve": "Ärmel",
      "sleeves": "Ärmel",
      "body": "Rumpf",
      "front": "Vorderteil",
      "back": "Rückenteil",
      "cuff": "Bündchen",
      "collar": "Kragen",
      "neckline": "Halsausschnitt",
      "neckband": "Halsblende",
      "yoke": "Passe",
      "raglan": "Raglan",
      "saddle shoulder": "Sattelschulter",
      "set-in sleeve": "eingesetzter Ärmel",
      "armhole": "Armloch",
      "shoulder": "Schulter",
      "shoulders": "Schultern",
      "hem": "Saum",
      "buttonhole": "Knopfloch",
      "buttonband": "Knopfleiste",
      "waist shaping": "Taillierung",
      "bust darts": "Brustabnäher",

      // === SOCK PARTS ===
      "heel": "Ferse",
      "heel flap": "Fersenwand",
      "heel turn": "Fersenkäppchen",
      "gusset": "Zwickel",
      "toe": "Spitze",
      "instep": "Spann",
      "sole": "Sohle",
      "leg": "Schaft",
      "top down": "von oben nach unten",
      "toe up": "von der Spitze hoch",
      "cuff down": "vom Bündchen runter",
      "two at a time": "beide gleichzeitig",
      "taat": "beide gleichzeitig",
      "short row heel": "Bumerangferse",
      "afterthought heel": "nachträgliche Ferse",

      // === FINISHING ===
      "seam": "Naht",
      "seaming": "zusammennähen",
      "weave in ends": "Fäden vernähen",
      "block": "spannen",
      "blocking": "Spannen",
      "wet blocking": "Nassblockieren",
      "steam blocking": "Dampfspannen",
      "pin": "feststecken",
      "blocking mats": "Spannmatten",
      "blocking wires": "Spanndrähte",
      "finishing": "Fertigstellung",
      "grafting": "zusammenstricken",

      // === CONSTRUCTION ===
      "seamless": "nahtlos",
      "seamed": "mit Nähten",
      "bottom up": "von unten nach oben",
      "piece": "Teil",
      "beginning": "Anfang",
      "beg": "Anf.",
      "end": "Ende",
      "all": "alle",
      "work": "arbeite",
      "measures": "misst",
      "pattern": "Muster",

      // === GAUGE ===
      "gauge": "Maschenprobe",
      "gauge swatch": "Maschenprobe",
      "swatch": "Probeläppchen",
      "stitches per inch": "Maschen pro Zoll",
      "rows per inch": "Reihen pro Zoll",

      // === YARN ===
      "yarn": "Garn",
      "skein": "Strang",
      "ball": "Knäuel",
      "hank": "Strang",
      "yardage": "Lauflänge",
      "fingering": "Sockenwolle",
      "sport": "Sportgarn",
      "dk": "DK",
      "worsted": "Worsted",
      "bulky": "dicke Wolle",
      "super bulky": "sehr dicke Wolle",

      // === MEASUREMENTS ===
      "cm": "cm",
      "inches": "Zoll",
      "inch": "Zoll"
    },
    complex: {
      // === DECREASES ===
      "k2tog": {
        translation: "2 M re zus.",
        description: "2 Maschen rechts zusammenstricken: Nadel von vorne durch 2 Maschen stecken und zusammen als eine Masche rechts abstricken. Ergibt eine rechtsgeneigt Abnahme.",
        videoId: "rK29DaJbE_w"
      },
      "k3tog": {
        translation: "3 M re zus.",
        description: "3 Maschen rechts zusammenstricken: Nadel von vorne durch 3 Maschen stecken und zusammen als eine Masche rechts abstricken. Ergibt eine doppelte rechtsgeneigte Abnahme.",
        videoId: "rK29DaJbE_w"
      },
      "ssk": {
        translation: "2 M re verschr. zus.",
        description: "2 Maschen rechts verschränkt zusammenstricken: Beide Maschen einzeln wie zum Rechtsstricken abheben, dann zusammen durch die hinteren Maschenglieder rechts abstricken. Ergibt eine linksgeneigte Abnahme.",
        videoId: "zglvYdU64oY"
      },
      "sssk": {
        translation: "3 M re verschr. zus.",
        description: "3 Maschen rechts verschränkt zusammenstricken: Alle drei Maschen einzeln wie zum Rechtsstricken abheben, dann zusammen durch die hinteren Maschenglieder rechts abstricken. Ergibt eine doppelte linksgeneigte Abnahme.",
        videoId: "zglvYdU64oY"
      },
      "sk2p": {
        translation: "1 M abh., 2 M re zus., abgeh. M überziehen",
        description: "Zentrierte Doppelabnahme: 1 Masche abheben, 2 Maschen rechts zusammenstricken, dann die abgehobene Masche über die gestrickte Masche ziehen. Ergibt 2 Abnahmen mit zentrierter Neigung.",
        videoId: "yhlVqd8hQ90"
      },
      "s2kp": {
        translation: "2 M abh., 1 M re, 2 abgeh. M überziehen",
        description: "Zentrierte Doppelabnahme: 2 Maschen zusammen abheben, 1 Masche rechts stricken, dann beide abgehobenen Maschen über die gestrickte Masche ziehen.",
        videoId: "yhlVqd8hQ90"
      },
      "cdd": {
        translation: "zentr. Doppelabnahme",
        description: "Central Double Decrease / Zentrierte Doppelabnahme: 2 Maschen zusammen wie zum Rechtsstricken abheben, 1 Masche rechts, die 2 abgehobenen Maschen überziehen.",
        videoId: "yhlVqd8hQ90"
      },
      "sl1-k1-psso": {
        translation: "1 M abh., 1 re, abgeh. M überz.",
        description: "1 Masche abheben, 1 Masche rechts stricken, die abgehobene Masche über die gestrickte Masche ziehen. Ergibt eine linksgeneigte Abnahme.",
        videoId: "Ve2ZDChcD7c"
      },

      // === INCREASES ===
      "kfbf": {
        translation: "re-vorn-hinten-vorn",
        description: "Dreifache Zunahme aus einer Masche: Rechts ins vordere Maschenglied, dann rechts ins hintere Maschenglied, dann nochmals rechts ins vordere Maschenglied stricken. Macht aus 1 Masche 3 Maschen.",
        videoId: "LR2szBDTOnw"
      },
      "m1l": {
        translation: "1 M li verschr. zun.",
        description: "1 Masche links verschränkt zunehmen: Den Querfaden zwischen den Maschen von vorne auf die linke Nadel nehmen und links verschränkt abstricken. Ergibt eine linksgeneigte Zunahme.",
        videoId: "VBRiN4Yc75w"
      },
      "m1r": {
        translation: "1 M re verschr. zun.",
        description: "1 Masche rechts verschränkt zunehmen: Den Querfaden zwischen den Maschen von hinten auf die linke Nadel nehmen und rechts verschränkt abstricken. Ergibt eine rechtsgeneigte Zunahme.",
        videoId: "VBRiN4Yc75w"
      },
      "m1p": {
        translation: "1 M li zun.",
        description: "1 Masche links zunehmen: Den Querfaden zwischen den Maschen aufnehmen und links abstricken.",
        videoId: "VBRiN4Yc75w"
      },
      "kll": {
        translation: "re Zunahme links",
        description: "Linke gehobene Zunahme: Die linke Schlaufe der Masche eine Reihe darunter aufnehmen und rechts stricken.",
        videoId: "VBRiN4Yc75w"
      },
      "krl": {
        translation: "re Zunahme rechts",
        description: "Rechte gehobene Zunahme: Die rechte Schlaufe der Masche eine Reihe darunter aufnehmen und rechts stricken.",
        videoId: "VBRiN4Yc75w"
      },
      "lifted increase": {
        translation: "gehobene Zunahme",
        description: "Eine Zunahme, bei der die Schlaufe der Masche aus der Vorreihe aufgenommen und gestrickt wird. Fast unsichtbar.",
        videoId: "VBRiN4Yc75w"
      },

      // === SLIP STITCHES ===
      "sl1": {
        translation: "1 M abh.",
        description: "1 Masche abheben: Die Masche wie zum Linksstricken von der linken auf die rechte Nadel heben, ohne sie zu stricken (wenn nicht anders angegeben).",
        videoId: "_Wh8kmdqfcw"
      },
      "sl1 wyif": {
        translation: "1 M abh. mit Faden vorne",
        description: "1 Masche mit dem Faden vor der Arbeit abheben.",
        videoId: "_Wh8kmdqfcw"
      },
      "sl1 wyib": {
        translation: "1 M abh. mit Faden hinten",
        description: "1 Masche mit dem Faden hinter der Arbeit abheben.",
        videoId: "_Wh8kmdqfcw"
      },

      // === TECHNIQUES ===
      "kitchener stitch": {
        translation: "Maschenstich",
        description: "Technik zum nahtlosen Verbinden von zwei offenen Maschenreihen mit einer Wollnadel. Das Ergebnis sieht aus wie eine gestrickte Reihe. Wird oft für Sockenspitzen verwendet.",
        videoId: "vTKCgX_d9oM"
      },
      "mattress stitch": {
        translation: "Matratzenstich",
        description: "Technik zum nahezu unsichtbaren Zusammennähen von Strickteilen entlang der Seitenkanten. Der Faden wird zwischen den Randmaschen durchgeführt.",
        videoId: "g8VgbMbHIhM"
      },
      "lifeline": {
        translation: "Hilfsfaden",
        description: "Ein Sicherungsfaden, der durch alle Maschen einer Reihe gezogen wird. Bei Fehlern kann man einfach bis zu dieser Stelle zurückkehren.",
        videoId: "mjJb51ybUw0"
      },
      "magic loop": {
        translation: "Magic Loop",
        description: "Technik zum Stricken kleiner Umfänge (Socken, Ärmel, Mützen) mit einer langen Rundstricknadel (80-100 cm). Das Seil wird in der Mitte herausgezogen.",
        videoId: "EghuOSceW7w"
      },
      "german short rows": {
        translation: "Deutsche verkürzte Reihen",
        description: "Technik für verkürzte Reihen ohne Wicklungen. Stattdessen wird eine Doppelmasche (Zwillingsmasche) gebildet. Sehr unauffällig im fertigen Gestrick.",
        videoId: "vDQJFTvqE8Q"
      },
      "japanese short rows": {
        translation: "Japanische verkürzte Reihen",
        description: "Technik für verkürzte Reihen, bei der Sicherheitsnadeln oder Maschenmarkierer verwendet werden, um die Wendestellen zu markieren.",
        videoId: "vDQJFTvqE8Q"
      },
      "wrap and turn": {
        translation: "Umwickeln und Wenden",
        description: "Standardtechnik für verkürzte Reihen: Die nächste Masche wird umwickelt, dann wird die Arbeit gewendet. Beim Zurückstricken wird die Wicklung mit der Masche zusammengestrickt.",
        videoId: "vDQJFTvqE8Q"
      },

      // === STITCH PATTERNS ===
      "fisherman's rib": {
        translation: "Patentmuster",
        description: "Ein besonders elastisches, dickes und wärmendes Rippenmuster. Entsteht durch das Stricken in die Masche der Vorreihe.",
        videoId: "et_2VBCUDU8"
      },
      "brioche": {
        translation: "Brioche/Patent",
        description: "Zweifarbiges oder einfarbiges weiches, elastisches Muster. Charakteristisch sind die umschlagenen Maschen und das reversible Erscheinungsbild.",
        videoId: "my9TSIKKclE"
      },
      "i-cord": {
        translation: "I-Kordel",
        description: "Eine schmale, schlauchförmige Kordel, die mit einem Nadelspiel oder zwei Nadeln hergestellt wird. Vielseitig einsetzbar für Träger, Schlaufen und Verzierungen.",
        videoId: "bQ6EjbEvjXY"
      },

      // === CAST ON TECHNIQUES ===
      "tubular cast on": {
        translation: "Italienischer Anschlag",
        description: "Ein elastischer, abgerundeter Anschlag für Bündchen, der wie industriell gefertigt aussieht. Beginnt mit Hilfsfaden und Umschlägen.",
        videoId: "gQpzPT8w6_E"
      },
      "judy's magic cast on": {
        translation: "Judy's magischer Anschlag",
        description: "Perfekter Anschlag für Toe-up Socken. Erzeugt eine geschlossene Spitze ohne Naht. Von Judy Becker erfunden.",
        videoId: "qkI9g5j9VBA"
      },

      // === COLORWORK ===
      "jogless join": {
        translation: "Nahtloser Rundenübergang",
        description: "Technik zum unsichtbaren Verbinden von Runden beim Stricken mit Farbwechsel. Verhindert den sichtbaren 'Treppeneffekt' am Rundenanfang.",
        videoId: "7YY1KJlTeeo"
      },
      "steek": {
        translation: "Steek",
        description: "Technik aus dem Fair-Isle-Stricken: Zusätzliche Maschen werden gestrickt und später aufgeschnitten, um Öffnungen für Ärmel oder Halsausschnitte zu schaffen.",
        videoId: "Yg_8VSMQUBY"
      },
      "stranded colorwork": {
        translation: "Jacquardstricken",
        description: "Stricktechnik mit mehreren Farben pro Reihe. Die nicht verwendeten Fäden werden auf der Rückseite mitgeführt (Spannfäden).",
        videoId: "sS3qrZdVy2k"
      },

      // === CABLES ===
      "cable": {
        translation: "Zopfmuster",
        description: "Maschen werden in einer bestimmten Reihenfolge verschränkt, um ein Zopfmuster zu erzeugen. Benötigt meist eine Zopfnadel.",
        videoId: "sS3qrZdVy2k"
      },
      "c4f": {
        translation: "4 M nach links verzopfen",
        description: "Cable 4 Front: 2 Maschen auf Zopfnadel VOR die Arbeit legen, 2 rechts stricken, dann die 2 Maschen von der Zopfnadel rechts stricken. Der Zopf neigt sich nach links.",
        videoId: "sS3qrZdVy2k"
      },
      "c4b": {
        translation: "4 M nach rechts verzopfen",
        description: "Cable 4 Back: 2 Maschen auf Zopfnadel HINTER die Arbeit legen, 2 rechts stricken, dann die 2 Maschen von der Zopfnadel rechts stricken. Der Zopf neigt sich nach rechts.",
        videoId: "sS3qrZdVy2k"
      },
      "c6f": {
        translation: "6 M nach links verzopfen",
        description: "Cable 6 Front: 3 Maschen auf Zopfnadel VOR die Arbeit legen, 3 rechts stricken, dann die 3 Maschen von der Zopfnadel rechts stricken.",
        videoId: "sS3qrZdVy2k"
      },
      "c6b": {
        translation: "6 M nach rechts verzopfen",
        description: "Cable 6 Back: 3 Maschen auf Zopfnadel HINTER die Arbeit legen, 3 rechts stricken, dann die 3 Maschen von der Zopfnadel rechts stricken.",
        videoId: "sS3qrZdVy2k"
      },
      "t3f": {
        translation: "3 M Twist nach links",
        description: "Twist 3 Front: 2 Maschen auf Zopfnadel vor die Arbeit, 1 links, dann die 2 Maschen rechts stricken.",
        videoId: "sS3qrZdVy2k"
      },
      "t3b": {
        translation: "3 M Twist nach rechts",
        description: "Twist 3 Back: 1 Masche auf Zopfnadel hinter die Arbeit, 2 rechts, dann die Masche links stricken.",
        videoId: "sS3qrZdVy2k"
      }
    },
    // UI strings for German
    ui: {
      charCount: "Zeichen",
      row: "Reihe",
      rows: "Reihen",
      round: "Runde",
      rounds: "Runden",
      times: "mal",
      stitchK: "re",
      stitchP: "li",
      betaNotice: "[Bonifaktur BETA-Übersetzung - Es können Fehler passieren. Wenn Du welche entdeckst, lass es uns bitte wissen!]",
      videoLink: "Video-Tutorial ansehen",
      statsText: "Begriffe übersetzt",
      statsSimple: "einfache",
      statsComplex: "komplexe Techniken",
      copied: "Kopiert!"
    }
  },

  // ============================================================
  // ITALIAN
  // ============================================================
  it: {
    simple: {
      // === BASIC STITCHES ===
      "k": "dir",
      "p": "rov",
      "knit": "dritto",
      "purl": "rovescio",
      "yo": "gettato",
      "sl": "pass.",
      "slip": "passare",
      "st": "m",
      "sts": "m",
      "stitch": "maglia",
      "stitches": "maglie",

      // === CAST ON METHODS ===
      "cast on": "avviare",
      "co": "avviare",
      "long tail cast on": "avvio a coda lunga",
      "cable cast on": "avvio a catenella",
      "knitted cast on": "avvio a maglia",
      "provisional cast on": "avvio provvisorio",
      "tubular cast on": "avvio tubolare",
      "italian cast on": "avvio tubolare",
      "judy's magic cast on": "avvio magico di Judy",
      "jmco": "avvio magico di Judy",
      "backwards loop cast on": "avvio ad anello",
      "backward loop cast on": "avvio ad anello",
      "german twisted cast on": "avvio tedesco ritorto",
      "old norwegian cast on": "avvio norvegese",
      "crochet cast on": "avvio all'uncinetto",
      "emily ocker's cast on": "avvio di Emily Ocker",
      "turkish cast on": "avvio turco",
      "figure 8 cast on": "avvio a otto",

      // === BIND OFF METHODS ===
      "bind off": "intrecciare",
      "bo": "intr.",
      "cast off": "intrecciare",
      "stretchy bind off": "intrecciatura elastica",
      "sewn bind off": "chiusura cucita",
      "three needle bind off": "chiusura a 3 ferri",
      "3 needle bind off": "chiusura a 3 ferri",
      "picot bind off": "chiusura a picot",
      "i-cord bind off": "chiusura a i-cord",
      "icord bind off": "chiusura a i-cord",
      "tubular bind off": "chiusura tubolare",
      "italian bind off": "chiusura tubolare",
      "suspended bind off": "chiusura sospesa",
      "jeny's surprisingly stretchy bind off": "chiusura elastica di Jeny",
      "jssbo": "chiusura elastica di Jeny",

      // === ROWS AND ROUNDS ===
      "row": "ferro",
      "rows": "ferri",
      "round": "giro",
      "rnd": "giro",
      "rounds": "giri",
      "rnds": "giri",
      "rs": "dir. lavoro",
      "ws": "rov. lavoro",
      "right side": "diritto del lavoro",
      "wrong side": "rovescio del lavoro",
      "in the round": "in tondo",
      "worked flat": "lavorato in piano",
      "back and forth": "avanti e indietro",
      "bor": "inizio giro",
      "beginning of round": "inizio del giro",
      "end of round": "fine del giro",

      // === BASIC INSTRUCTIONS ===
      "repeat": "ripetere",
      "rep": "rip.",
      "until": "fino a",
      "from": "da",
      "to end": "fino alla fine",
      "to last": "fino alle ultime",
      "across": "su tutto il ferro",
      "work even": "lavorare senza aumenti/diminuzioni",
      "continue": "continuare",
      "continue in pattern": "continuare a motivo",
      "at the same time": "contemporaneamente",
      "every other row": "ogni 2 ferri",
      "every 4th row": "ogni 4 ferri",
      "times": "volte",
      "times more": "volte in più",
      "remaining": "rimanenti",
      "rem": "rim.",

      // === INCREASES (SIMPLE) ===
      "increase": "aumentare",
      "inc": "aum.",
      "kfb": "dir. davanti e dietro",
      "pfb": "rov. davanti e dietro",
      "m1": "1 aum.",
      "make one": "aumentare 1 maglia",

      // === DECREASES (SIMPLE) ===
      "decrease": "diminuire",
      "dec": "dim.",
      "p2tog": "2 m rov. ins.",
      "p3tog": "3 m rov. ins.",
      "skp": "1 m pass., 1 dir., accav.",
      "psso": "accavallare",
      "pass slipped stitch over": "accavallare la maglia passata",

      // === STITCH PATTERNS ===
      "stockinette": "maglia rasata",
      "stockinette stitch": "maglia rasata",
      "st st": "m. rasata",
      "stocking stitch": "maglia rasata",
      "reverse stockinette": "maglia rasata rovescia",
      "reverse st st": "m. rasata rov.",
      "rev st st": "m. rasata rov.",
      "garter": "legaccio",
      "garter stitch": "punto legaccio",
      "ribbing": "coste",
      "rib": "costa",
      "1x1 rib": "costa 1/1",
      "2x2 rib": "costa 2/2",
      "seed stitch": "punto riso",
      "moss stitch": "punto muschio",
      "basketweave": "punto cesto",
      "honeycomb": "punto nido d'ape",
      "trinity stitch": "punto trinità",
      "blackberry stitch": "punto mora",
      "bobble": "nocciolina",
      "popcorn stitch": "punto popcorn",
      "lace": "traforato",
      "eyelet": "occhiello",
      "faggoting": "punto a giorno",
      "nupps": "nupps",
      "beaded": "con perline",

      // === CABLES ===
      "cable": "treccia",
      "cn": "ferro aus.",
      "cable needle": "ferro ausiliario",
      "twist": "torciglione",
      "hold in front": "tenere davanti",
      "hold in back": "tenere dietro",
      "cross": "incrociare",

      // === COLORWORK ===
      "mc": "CP",
      "main color": "colore principale",
      "cc": "CC",
      "contrast color": "colore contrastante",
      "color a": "colore A",
      "color b": "colore B",
      "color c": "colore C",
      "stranded": "jacquard",
      "stranded colorwork": "jacquard",
      "fair isle": "Fair Isle",
      "intarsia": "intarsio",
      "mosaic knitting": "maglia a mosaico",
      "double knitting": "doppia maglia",
      "float": "filo teso",
      "catch float": "fermare il filo teso",
      "steek": "steek",
      "dominant color": "colore dominante",

      // === SHORT ROWS ===
      "short rows": "ferri accorciati",
      "turn": "girare",
      "wrap and turn": "avvolgere e girare",
      "w&t": "avv. e gir.",
      "w+t": "avv. e gir.",
      "pick up wrap": "riprendere l'avvolgimento",
      "hide wrap": "nascondere l'avvolgimento",
      "shadow wrap": "avvolgimento ombra",
      "twin stitch": "maglia gemella",

      // === NEEDLES ===
      "dpn": "ferri a doppia punta",
      "dpns": "ferri a doppia punta",
      "double pointed needles": "ferri a doppia punta",
      "circular needle": "ferro circolare",
      "circulars": "ferri circolari",
      "straight needles": "ferri dritti",
      "interchangeable": "intercambiabili",
      "cable length": "lunghezza cavo",

      // === TECHNIQUES ===
      "join": "unire",
      "join for working in the round": "unire per lavorare in tondo",
      "place marker": "posizionare marcatore",
      "pm": "pos. marc.",
      "slip marker": "passare il marcatore",
      "sm": "pass. marc.",
      "marker": "marcatore",
      "pick up": "riprendere",
      "pick up and knit": "riprendere e lavorare a dritto",
      "pick up and purl": "riprendere e lavorare a rovescio",
      "knitwise": "come per lavorare a dritto",
      "purlwise": "come per lavorare a rovescio",
      "tbl": "ritorto",
      "through back loop": "nel filo dietro",
      "wyib": "filo dietro",
      "wyif": "filo davanti",
      "with yarn in back": "con filo dietro",
      "with yarn in front": "con filo davanti",
      "hold": "mettere in attesa",
      "place on holder": "mettere su ferma-maglie",
      "set aside": "mettere da parte",
      "break yarn": "tagliare il filo",
      "join yarn": "attaccare il filo",

      // === GARMENT PARTS ===
      "sleeve": "manica",
      "sleeves": "maniche",
      "body": "corpo",
      "front": "davanti",
      "back": "dietro",
      "cuff": "polsino",
      "collar": "colletto",
      "neckline": "scollatura",
      "neckband": "bordo collo",
      "yoke": "sprone",
      "raglan": "raglan",
      "saddle shoulder": "spalla a sella",
      "set-in sleeve": "manica a giro",
      "armhole": "giromanica",
      "shoulder": "spalla",
      "shoulders": "spalle",
      "hem": "orlo",
      "buttonhole": "asola",
      "buttonband": "abbottonatura",
      "waist shaping": "modellatura vita",
      "bust darts": "pince seno",

      // === SOCK PARTS ===
      "heel": "tallone",
      "heel flap": "pattina del tallone",
      "heel turn": "svolta del tallone",
      "gusset": "soffietto",
      "toe": "punta",
      "instep": "collo del piede",
      "sole": "suola",
      "leg": "gamba",
      "top down": "dall'alto in basso",
      "toe up": "dalla punta in su",
      "cuff down": "dal polsino in giù",
      "two at a time": "due alla volta",
      "taat": "due alla volta",
      "short row heel": "tallone a ferri accorciati",
      "afterthought heel": "tallone posticipato",

      // === FINISHING ===
      "seam": "cucitura",
      "seaming": "cucire",
      "weave in ends": "nascondere i fili",
      "block": "bloccare",
      "blocking": "bloccaggio",
      "wet blocking": "bloccaggio a umido",
      "steam blocking": "bloccaggio a vapore",
      "pin": "fissare con spilli",
      "blocking mats": "tappetini per bloccaggio",
      "blocking wires": "fili per bloccaggio",
      "finishing": "rifinitura",
      "grafting": "grafting",

      // === CONSTRUCTION ===
      "seamless": "senza cuciture",
      "seamed": "con cuciture",
      "bottom up": "dal basso in alto",
      "piece": "pezzo",
      "beginning": "inizio",
      "beg": "iniz.",
      "end": "fine",
      "all": "tutte",
      "work": "lavorare",
      "measures": "misura",
      "pattern": "schema",

      // === GAUGE ===
      "gauge": "campione",
      "gauge swatch": "campione",
      "swatch": "campione",
      "stitches per inch": "maglie per pollice",
      "rows per inch": "ferri per pollice",

      // === YARN ===
      "yarn": "filato",
      "skein": "matassa",
      "ball": "gomitolo",
      "hank": "matassa",
      "yardage": "metraggio",
      "fingering": "fingering",
      "sport": "sport",
      "dk": "DK",
      "worsted": "worsted",
      "bulky": "grosso",
      "super bulky": "super grosso",

      // === MEASUREMENTS ===
      "cm": "cm",
      "inches": "pollici",
      "inch": "pollice"
    },
    complex: {
      // === DECREASES ===
      "k2tog": {
        translation: "2 m dir. ins.",
        description: "Lavorare 2 maglie insieme a dritto: Inserire il ferro nelle 2 maglie successive da sinistra a destra e lavorarle insieme come una sola maglia a dritto. Risulta una diminuzione inclinata a destra."
      },
      "k3tog": {
        translation: "3 m dir. ins.",
        description: "Lavorare 3 maglie insieme a dritto: Inserire il ferro nelle 3 maglie successive e lavorarle insieme come una sola maglia. Risulta una doppia diminuzione inclinata a destra."
      },
      "ssk": {
        translation: "2 m dir. rit. ins.",
        description: "Passare 2 maglie una alla volta come per lavorarle a dritto, poi lavorarle insieme nel filo dietro. Risulta una diminuzione inclinata a sinistra."
      },
      "sssk": {
        translation: "3 m dir. rit. ins.",
        description: "Passare 3 maglie una alla volta come per lavorarle a dritto, poi lavorarle insieme nel filo dietro. Risulta una doppia diminuzione inclinata a sinistra."
      },
      "sk2p": {
        translation: "1 m pass., 2 m dir. ins., accav.",
        description: "Diminuzione doppia centrata: Passare 1 maglia, lavorare 2 maglie insieme a dritto, accavallare la maglia passata. Risulta 2 diminuzioni con inclinazione centrata."
      },
      "s2kp": {
        translation: "2 m pass., 1 dir., 2 m accav.",
        description: "Diminuzione doppia centrata: Passare 2 maglie insieme, lavorare 1 maglia a dritto, accavallare le 2 maglie passate."
      },
      "cdd": {
        translation: "dim. doppia centr.",
        description: "Central Double Decrease / Diminuzione doppia centrata: Passare 2 maglie insieme come per lavorarle a dritto, lavorare 1 maglia a dritto, accavallare le 2 maglie passate."
      },
      "sl1-k1-psso": {
        translation: "1 m pass., 1 dir., accav.",
        description: "Passare 1 maglia, lavorare 1 maglia a dritto, accavallare la maglia passata. Risulta una diminuzione inclinata a sinistra."
      },

      // === INCREASES ===
      "kfbf": {
        translation: "dir.-dav.-dietro-dav.",
        description: "Triplo aumento da una maglia: Lavorare a dritto nel filo davanti, poi nel filo dietro, poi di nuovo nel filo davanti. Da 1 maglia ne ottieni 3."
      },
      "m1l": {
        translation: "1 aum. a sinistra",
        description: "Aumento con inclinazione a sinistra: Sollevare il filo tra le maglie dal davanti con il ferro sinistro e lavorarlo a dritto ritorto."
      },
      "m1r": {
        translation: "1 aum. a destra",
        description: "Aumento con inclinazione a destra: Sollevare il filo tra le maglie dal dietro con il ferro sinistro e lavorarlo a dritto ritorto."
      },
      "m1p": {
        translation: "1 aum. a rov.",
        description: "Aumentare 1 maglia a rovescio: Sollevare il filo tra le maglie e lavorarlo a rovescio."
      },
      "kll": {
        translation: "aum. sollevato sin.",
        description: "Aumento sollevato sinistro: Sollevare l'ansa sinistra della maglia del ferro precedente e lavorarla a dritto."
      },
      "krl": {
        translation: "aum. sollevato dex.",
        description: "Aumento sollevato destro: Sollevare l'ansa destra della maglia del ferro precedente e lavorarla a dritto."
      },
      "lifted increase": {
        translation: "aumento sollevato",
        description: "Un aumento dove si solleva l'ansa della maglia dal ferro precedente e la si lavora. Quasi invisibile."
      },

      // === SLIP STITCHES ===
      "sl1": {
        translation: "1 m pass.",
        description: "Passare 1 maglia: Passare la maglia dal ferro sinistro al destro senza lavorarla (come per lavorarla a rovescio se non indicato diversamente)."
      },
      "sl1 wyif": {
        translation: "1 m pass. filo dav.",
        description: "Passare 1 maglia con il filo davanti al lavoro."
      },
      "sl1 wyib": {
        translation: "1 m pass. filo dietro",
        description: "Passare 1 maglia con il filo dietro al lavoro."
      },

      // === TECHNIQUES ===
      "kitchener stitch": {
        translation: "punto maglia",
        description: "Tecnica per unire invisibilmente due serie di maglie aperte con un ago da lana. Il risultato sembra un ferro lavorato. Usato spesso per le punte dei calzini."
      },
      "mattress stitch": {
        translation: "punto materasso",
        description: "Tecnica per cucire quasi invisibilmente i pezzi a maglia lungo i bordi laterali. Il filo passa tra le maglie di bordo."
      },
      "lifeline": {
        translation: "filo di sicurezza",
        description: "Un filo di sicurezza passato attraverso tutte le maglie di un ferro. In caso di errori si può facilmente tornare a questo punto."
      },
      "magic loop": {
        translation: "magic loop",
        description: "Tecnica per lavorare piccole circonferenze (calzini, maniche, cappelli) con un ferro circolare lungo (80-100 cm). Il cavo viene tirato fuori a metà."
      },
      "german short rows": {
        translation: "ferri accorciati tedeschi",
        description: "Tecnica per ferri accorciati senza avvolgimenti. Si forma invece una maglia doppia (maglia gemella). Molto discreto nel lavoro finito."
      },
      "japanese short rows": {
        translation: "ferri accorciati giapponesi",
        description: "Tecnica per ferri accorciati usando spille o marcatori per segnare i punti di svolta."
      },
      "wrap and turn": {
        translation: "avvolgere e girare",
        description: "Tecnica standard per ferri accorciati: La maglia successiva viene avvolta, poi si gira il lavoro. Al ritorno l'avvolgimento viene lavorato insieme alla maglia."
      },

      // === STITCH PATTERNS ===
      "fisherman's rib": {
        translation: "punto inglese",
        description: "Un motivo a coste particolarmente elastico, spesso e caldo. Si ottiene lavorando nella maglia del ferro precedente."
      },
      "brioche": {
        translation: "brioche",
        description: "Motivo morbido ed elastico, monocromatico o bicolore. Caratterizzato dalle maglie con gettato e dall'aspetto reversibile."
      },
      "i-cord": {
        translation: "i-cord",
        description: "Un cordoncino tubolare stretto fatto con ferri a doppia punta o due ferri. Versatile per manici, passanti e decorazioni."
      },

      // === CAST ON TECHNIQUES ===
      "tubular cast on": {
        translation: "avvio tubolare",
        description: "Un avvio elastico e arrotondato per bordi a coste, dall'aspetto professionale. Inizia con filo ausiliario e gettati."
      },
      "judy's magic cast on": {
        translation: "avvio magico di Judy",
        description: "Avvio perfetto per calzini toe-up. Crea una punta chiusa senza cucitura. Inventato da Judy Becker."
      },

      // === COLORWORK ===
      "jogless join": {
        translation: "giunzione senza scalino",
        description: "Tecnica per unire invisibilmente i giri quando si lavora con cambio colore. Evita il visibile 'effetto scala' all'inizio del giro."
      },
      "steek": {
        translation: "steek",
        description: "Tecnica dal Fair Isle: Maglie extra vengono lavorate e poi tagliate per creare aperture per maniche o scollature."
      },
      "stranded colorwork": {
        translation: "jacquard",
        description: "Tecnica a maglia con più colori per ferro. I fili non usati vengono portati sul retro (fili tesi)."
      },

      // === CABLES ===
      "cable": {
        translation: "treccia",
        description: "Le maglie vengono incrociate in un ordine specifico per creare un motivo a treccia. Richiede solitamente un ferro ausiliario."
      },
      "c4f": {
        translation: "4 m incr. a sin.",
        description: "Cable 4 Front: Mettere 2 maglie sul ferro ausiliario DAVANTI al lavoro, lavorare 2 maglie a dritto, poi le 2 maglie dal ferro ausiliario a dritto. La treccia si inclina a sinistra."
      },
      "c4b": {
        translation: "4 m incr. a dex.",
        description: "Cable 4 Back: Mettere 2 maglie sul ferro ausiliario DIETRO al lavoro, lavorare 2 maglie a dritto, poi le 2 maglie dal ferro ausiliario a dritto. La treccia si inclina a destra."
      },
      "c6f": {
        translation: "6 m incr. a sin.",
        description: "Cable 6 Front: Mettere 3 maglie sul ferro ausiliario DAVANTI al lavoro, lavorare 3 maglie a dritto, poi le 3 maglie dal ferro ausiliario a dritto."
      },
      "c6b": {
        translation: "6 m incr. a dex.",
        description: "Cable 6 Back: Mettere 3 maglie sul ferro ausiliario DIETRO al lavoro, lavorare 3 maglie a dritto, poi le 3 maglie dal ferro ausiliario a dritto."
      },
      "t3f": {
        translation: "3 m torc. a sin.",
        description: "Twist 3 Front: 2 maglie sul ferro ausiliario davanti al lavoro, 1 rovescio, poi le 2 maglie a dritto."
      },
      "t3b": {
        translation: "3 m torc. a dex.",
        description: "Twist 3 Back: 1 maglia sul ferro ausiliario dietro al lavoro, 2 dritto, poi la maglia a rovescio."
      }
    },
    ui: {
      charCount: "caratteri",
      row: "Ferro",
      rows: "Ferri",
      round: "Giro",
      rounds: "Giri",
      times: "volte",
      stitchK: "dir",
      stitchP: "rov",
      betaNotice: "[Bonifaktur traduzione BETA - Possono esserci errori. Se ne trovi, faccelo sapere!]",
      videoLink: "Guarda il video tutorial",
      statsText: "termini tradotti",
      statsSimple: "semplici",
      statsComplex: "tecniche complesse",
      copied: "Copiato!"
    }
  },

  // ============================================================
  // FRENCH
  // ============================================================
  fr: {
    simple: {
      // === BASIC STITCHES ===
      "k": "end",
      "p": "env",
      "knit": "maille endroit",
      "purl": "maille envers",
      "yo": "jeté",
      "sl": "gl.",
      "slip": "glisser",
      "st": "m",
      "sts": "m",
      "stitch": "maille",
      "stitches": "mailles",

      // === CAST ON METHODS ===
      "cast on": "monter",
      "co": "monter",
      "long tail cast on": "montage à l'italienne",
      "cable cast on": "montage tricoté câblé",
      "knitted cast on": "montage tricoté",
      "provisional cast on": "montage provisoire",
      "tubular cast on": "montage tubulaire",
      "italian cast on": "montage tubulaire",
      "judy's magic cast on": "montage magique de Judy",
      "jmco": "montage magique de Judy",
      "backwards loop cast on": "montage à boucles",
      "backward loop cast on": "montage à boucles",
      "german twisted cast on": "montage allemand torsadé",
      "old norwegian cast on": "montage norvégien",
      "crochet cast on": "montage au crochet",
      "emily ocker's cast on": "montage d'Emily Ocker",
      "turkish cast on": "montage turc",
      "figure 8 cast on": "montage en huit",

      // === BIND OFF METHODS ===
      "bind off": "rabattre",
      "bo": "rab.",
      "cast off": "rabattre",
      "stretchy bind off": "rabattage élastique",
      "sewn bind off": "rabattage cousu",
      "three needle bind off": "rabattage à 3 aiguilles",
      "3 needle bind off": "rabattage à 3 aiguilles",
      "picot bind off": "rabattage picot",
      "i-cord bind off": "rabattage i-cord",
      "icord bind off": "rabattage i-cord",
      "tubular bind off": "rabattage tubulaire",
      "italian bind off": "rabattage tubulaire",
      "suspended bind off": "rabattage suspendu",
      "jeny's surprisingly stretchy bind off": "rabattage élastique de Jeny",
      "jssbo": "rabattage élastique de Jeny",

      // === ROWS AND ROUNDS ===
      "row": "rang",
      "rows": "rangs",
      "round": "tour",
      "rnd": "tour",
      "rounds": "tours",
      "rnds": "tours",
      "rs": "end.",
      "ws": "env.",
      "right side": "endroit",
      "wrong side": "envers",
      "in the round": "en rond",
      "worked flat": "tricoté à plat",
      "back and forth": "en allers-retours",
      "bor": "début du tour",
      "beginning of round": "début du tour",
      "end of round": "fin du tour",

      // === BASIC INSTRUCTIONS ===
      "repeat": "répéter",
      "rep": "rép.",
      "until": "jusqu'à",
      "from": "de",
      "to end": "jusqu'à la fin",
      "to last": "jusqu'aux dernières",
      "across": "sur tout le rang",
      "work even": "tricoter sans augm./dim.",
      "continue": "continuer",
      "continue in pattern": "continuer au point",
      "at the same time": "en même temps",
      "every other row": "tous les 2 rangs",
      "every 4th row": "tous les 4 rangs",
      "times": "fois",
      "times more": "fois de plus",
      "remaining": "restantes",
      "rem": "rest.",

      // === INCREASES (SIMPLE) ===
      "increase": "augmenter",
      "inc": "augm.",
      "kfb": "end. av. et arr.",
      "pfb": "env. av. et arr.",
      "m1": "1 augm.",
      "make one": "augmenter 1 maille",

      // === DECREASES (SIMPLE) ===
      "decrease": "diminuer",
      "dec": "dim.",
      "p2tog": "2 m env. ens.",
      "p3tog": "3 m env. ens.",
      "skp": "1 m gl., 1 end., passer m gl. par-dessus",
      "psso": "passer par-dessus",
      "pass slipped stitch over": "passer la maille glissée par-dessus",

      // === STITCH PATTERNS ===
      "stockinette": "jersey endroit",
      "stockinette stitch": "jersey endroit",
      "st st": "jersey",
      "stocking stitch": "jersey endroit",
      "reverse stockinette": "jersey envers",
      "reverse st st": "jersey envers",
      "rev st st": "jersey envers",
      "garter": "point mousse",
      "garter stitch": "point mousse",
      "ribbing": "côtes",
      "rib": "côte",
      "1x1 rib": "côtes 1/1",
      "2x2 rib": "côtes 2/2",
      "seed stitch": "point de riz",
      "moss stitch": "point de blé",
      "basketweave": "point de vannerie",
      "honeycomb": "point nid d'abeille",
      "trinity stitch": "point trinité",
      "blackberry stitch": "point de mûre",
      "bobble": "nope",
      "popcorn stitch": "point popcorn",
      "lace": "dentelle",
      "eyelet": "œillet",
      "faggoting": "point de fagot",
      "nupps": "nupps",
      "beaded": "avec perles",

      // === CABLES ===
      "cable": "torsade",
      "cn": "aig. aux.",
      "cable needle": "aiguille auxiliaire",
      "twist": "croisement",
      "hold in front": "tenir devant",
      "hold in back": "tenir derrière",
      "cross": "croiser",

      // === COLORWORK ===
      "mc": "CP",
      "main color": "couleur principale",
      "cc": "CC",
      "contrast color": "couleur contrastante",
      "color a": "couleur A",
      "color b": "couleur B",
      "color c": "couleur C",
      "stranded": "jacquard",
      "stranded colorwork": "jacquard",
      "fair isle": "Fair Isle",
      "intarsia": "intarsia",
      "mosaic knitting": "tricot mosaïque",
      "double knitting": "double tricot",
      "float": "fil flottant",
      "catch float": "fixer le fil flottant",
      "steek": "steek",
      "dominant color": "couleur dominante",

      // === SHORT ROWS ===
      "short rows": "rangs raccourcis",
      "turn": "tourner",
      "wrap and turn": "envelopper et tourner",
      "w&t": "env. et tourner",
      "w+t": "env. et tourner",
      "pick up wrap": "relever l'enveloppe",
      "hide wrap": "cacher l'enveloppe",
      "shadow wrap": "enveloppe ombre",
      "twin stitch": "maille jumelle",

      // === NEEDLES ===
      "dpn": "aig. double pointe",
      "dpns": "aig. double pointe",
      "double pointed needles": "aiguilles double pointe",
      "circular needle": "aiguille circulaire",
      "circulars": "aiguilles circulaires",
      "straight needles": "aiguilles droites",
      "interchangeable": "interchangeables",
      "cable length": "longueur du câble",

      // === TECHNIQUES ===
      "join": "joindre",
      "join for working in the round": "joindre pour tricoter en rond",
      "place marker": "placer marqueur",
      "pm": "pl. marq.",
      "slip marker": "glisser marqueur",
      "sm": "gl. marq.",
      "marker": "marqueur",
      "pick up": "relever",
      "pick up and knit": "relever et tricoter à l'endroit",
      "pick up and purl": "relever et tricoter à l'envers",
      "knitwise": "comme pour tricoter à l'endroit",
      "purlwise": "comme pour tricoter à l'envers",
      "tbl": "torse",
      "through back loop": "dans le brin arrière",
      "wyib": "fil derrière",
      "wyif": "fil devant",
      "with yarn in back": "avec le fil derrière",
      "with yarn in front": "avec le fil devant",
      "hold": "mettre en attente",
      "place on holder": "mettre sur arrête-mailles",
      "set aside": "mettre de côté",
      "break yarn": "couper le fil",
      "join yarn": "attacher le fil",

      // === GARMENT PARTS ===
      "sleeve": "manche",
      "sleeves": "manches",
      "body": "corps",
      "front": "devant",
      "back": "dos",
      "cuff": "poignet",
      "collar": "col",
      "neckline": "encolure",
      "neckband": "bordure d'encolure",
      "yoke": "empiècement",
      "raglan": "raglan",
      "saddle shoulder": "épaule en selle",
      "set-in sleeve": "manche montée",
      "armhole": "emmanchure",
      "shoulder": "épaule",
      "shoulders": "épaules",
      "hem": "ourlet",
      "buttonhole": "boutonnière",
      "buttonband": "bande de boutonnage",
      "waist shaping": "mise en forme taille",
      "bust darts": "pinces poitrine",

      // === SOCK PARTS ===
      "heel": "talon",
      "heel flap": "talon à rabat",
      "heel turn": "tournant du talon",
      "gusset": "gousset",
      "toe": "pointe",
      "instep": "cou-de-pied",
      "sole": "semelle",
      "leg": "jambe",
      "top down": "de haut en bas",
      "toe up": "de la pointe vers le haut",
      "cuff down": "du poignet vers le bas",
      "two at a time": "deux à la fois",
      "taat": "deux à la fois",
      "short row heel": "talon en rangs raccourcis",
      "afterthought heel": "talon après coup",

      // === FINISHING ===
      "seam": "couture",
      "seaming": "coudre",
      "weave in ends": "rentrer les fils",
      "block": "bloquer",
      "blocking": "blocage",
      "wet blocking": "blocage humide",
      "steam blocking": "blocage à la vapeur",
      "pin": "épingler",
      "blocking mats": "tapis de blocage",
      "blocking wires": "fils de blocage",
      "finishing": "finitions",
      "grafting": "grafting",

      // === CONSTRUCTION ===
      "seamless": "sans couture",
      "seamed": "avec coutures",
      "bottom up": "de bas en haut",
      "piece": "pièce",
      "beginning": "début",
      "beg": "déb.",
      "end": "fin",
      "all": "toutes",
      "work": "tricoter",
      "measures": "mesure",
      "pattern": "modèle",

      // === GAUGE ===
      "gauge": "échantillon",
      "gauge swatch": "échantillon",
      "swatch": "échantillon",
      "stitches per inch": "mailles par pouce",
      "rows per inch": "rangs par pouce",

      // === YARN ===
      "yarn": "fil",
      "skein": "écheveau",
      "ball": "pelote",
      "hank": "écheveau",
      "yardage": "métrage",
      "fingering": "fingering",
      "sport": "sport",
      "dk": "DK",
      "worsted": "worsted",
      "bulky": "gros",
      "super bulky": "très gros",

      // === MEASUREMENTS ===
      "cm": "cm",
      "inches": "pouces",
      "inch": "pouce"
    },
    complex: {
      // === DECREASES ===
      "k2tog": {
        translation: "2 m end. ens.",
        description: "Tricoter 2 mailles ensemble à l'endroit: Piquer l'aiguille dans les 2 mailles suivantes de gauche à droite et les tricoter ensemble comme une seule maille. Donne une diminution inclinée à droite."
      },
      "k3tog": {
        translation: "3 m end. ens.",
        description: "Tricoter 3 mailles ensemble à l'endroit: Piquer l'aiguille dans les 3 mailles suivantes et les tricoter ensemble. Donne une double diminution inclinée à droite."
      },
      "ssk": {
        translation: "2 m end. torse ens.",
        description: "Glisser 2 mailles une par une comme pour les tricoter à l'endroit, puis les tricoter ensemble dans le brin arrière. Donne une diminution inclinée à gauche."
      },
      "sssk": {
        translation: "3 m end. torse ens.",
        description: "Glisser 3 mailles une par une comme pour les tricoter à l'endroit, puis les tricoter ensemble dans le brin arrière. Donne une double diminution inclinée à gauche."
      },
      "sk2p": {
        translation: "1 m gl., 2 m end. ens., passer",
        description: "Double diminution centrée: Glisser 1 maille, tricoter 2 mailles ensemble à l'endroit, passer la maille glissée par-dessus. Donne 2 diminutions avec inclinaison centrée."
      },
      "s2kp": {
        translation: "2 m gl., 1 end., passer 2 m",
        description: "Double diminution centrée: Glisser 2 mailles ensemble, tricoter 1 maille à l'endroit, passer les 2 mailles glissées par-dessus."
      },
      "cdd": {
        translation: "dim. double centr.",
        description: "Central Double Decrease / Double diminution centrée: Glisser 2 mailles ensemble comme pour les tricoter à l'endroit, tricoter 1 maille à l'endroit, passer les 2 mailles glissées."
      },
      "sl1-k1-psso": {
        translation: "1 m gl., 1 end., passer",
        description: "Glisser 1 maille, tricoter 1 maille à l'endroit, passer la maille glissée par-dessus. Donne une diminution inclinée à gauche."
      },

      // === INCREASES ===
      "kfbf": {
        translation: "end.-av.-arr.-av.",
        description: "Triple augmentation dans une maille: Tricoter à l'endroit dans le brin avant, puis dans le brin arrière, puis à nouveau dans le brin avant. Fait 3 mailles à partir d'une."
      },
      "m1l": {
        translation: "1 augm. à gauche",
        description: "Augmentation inclinée à gauche: Relever le fil entre les mailles par l'avant avec l'aiguille gauche et le tricoter à l'endroit torse."
      },
      "m1r": {
        translation: "1 augm. à droite",
        description: "Augmentation inclinée à droite: Relever le fil entre les mailles par l'arrière avec l'aiguille gauche et le tricoter à l'endroit torse."
      },
      "m1p": {
        translation: "1 augm. env.",
        description: "Augmenter 1 maille à l'envers: Relever le fil entre les mailles et le tricoter à l'envers."
      },
      "kll": {
        translation: "augm. relevée g.",
        description: "Augmentation relevée gauche: Relever la boucle gauche de la maille du rang précédent et la tricoter à l'endroit."
      },
      "krl": {
        translation: "augm. relevée d.",
        description: "Augmentation relevée droite: Relever la boucle droite de la maille du rang précédent et la tricoter à l'endroit."
      },
      "lifted increase": {
        translation: "augmentation relevée",
        description: "Une augmentation où on relève la boucle de la maille du rang précédent et on la tricote. Presque invisible."
      },

      // === SLIP STITCHES ===
      "sl1": {
        translation: "1 m gl.",
        description: "Glisser 1 maille: Passer la maille de l'aiguille gauche à la droite sans la tricoter (comme pour l'envers si non précisé)."
      },
      "sl1 wyif": {
        translation: "1 m gl. fil dev.",
        description: "Glisser 1 maille avec le fil devant le travail."
      },
      "sl1 wyib": {
        translation: "1 m gl. fil derr.",
        description: "Glisser 1 maille avec le fil derrière le travail."
      },

      // === TECHNIQUES ===
      "kitchener stitch": {
        translation: "point de grafting",
        description: "Technique pour assembler invisiblement deux rangs de mailles ouvertes avec une aiguille à laine. Le résultat ressemble à un rang tricoté. Souvent utilisé pour les pointes de chaussettes."
      },
      "mattress stitch": {
        translation: "point de matelas",
        description: "Technique pour coudre presque invisiblement les pièces tricotées le long des bords. Le fil passe entre les mailles de lisière."
      },
      "lifeline": {
        translation: "fil de secours",
        description: "Un fil de sécurité passé à travers toutes les mailles d'un rang. En cas d'erreur, on peut facilement revenir à ce point."
      },
      "magic loop": {
        translation: "magic loop",
        description: "Technique pour tricoter de petites circonférences (chaussettes, manches, bonnets) avec une longue aiguille circulaire (80-100 cm). Le câble est tiré au milieu."
      },
      "german short rows": {
        translation: "rangs raccourcis allemands",
        description: "Technique de rangs raccourcis sans enveloppes. Une maille double (maille jumelle) est formée à la place. Très discret dans le tricot fini."
      },
      "japanese short rows": {
        translation: "rangs raccourcis japonais",
        description: "Technique de rangs raccourcis utilisant des épingles ou marqueurs pour marquer les points de retournement."
      },
      "wrap and turn": {
        translation: "envelopper et tourner",
        description: "Technique standard pour rangs raccourcis: La maille suivante est enveloppée, puis le travail est retourné. Au retour, l'enveloppe est tricotée avec la maille."
      },

      // === STITCH PATTERNS ===
      "fisherman's rib": {
        translation: "côtes anglaises",
        description: "Un point côtes particulièrement élastique, épais et chaud. Se fait en tricotant dans la maille du rang précédent."
      },
      "brioche": {
        translation: "brioche",
        description: "Point doux et élastique, uni ou bicolore. Caractérisé par les mailles avec jeté et l'aspect réversible."
      },
      "i-cord": {
        translation: "i-cord",
        description: "Un cordon tubulaire étroit fait avec des aiguilles double pointe ou deux aiguilles. Polyvalent pour les anses, passants et décorations."
      },

      // === CAST ON TECHNIQUES ===
      "tubular cast on": {
        translation: "montage tubulaire",
        description: "Un montage élastique et arrondi pour les bordures côtelées, d'aspect professionnel. Commence avec un fil auxiliaire et des jetés."
      },
      "judy's magic cast on": {
        translation: "montage magique de Judy",
        description: "Montage parfait pour les chaussettes toe-up. Crée une pointe fermée sans couture. Inventé par Judy Becker."
      },

      // === COLORWORK ===
      "jogless join": {
        translation: "jonction sans décalage",
        description: "Technique pour joindre invisiblement les tours lors du tricot avec changement de couleur. Évite l'effet 'escalier' visible au début du tour."
      },
      "steek": {
        translation: "steek",
        description: "Technique du Fair Isle: Des mailles supplémentaires sont tricotées puis coupées pour créer des ouvertures pour les manches ou l'encolure."
      },
      "stranded colorwork": {
        translation: "jacquard",
        description: "Technique de tricot avec plusieurs couleurs par rang. Les fils non utilisés sont portés à l'arrière (fils flottants)."
      },

      // === CABLES ===
      "cable": {
        translation: "torsade",
        description: "Les mailles sont croisées dans un ordre spécifique pour créer un motif torsadé. Nécessite généralement une aiguille auxiliaire."
      },
      "c4f": {
        translation: "4 m tors. à g.",
        description: "Cable 4 Front: Placer 2 mailles sur l'aiguille auxiliaire DEVANT le travail, tricoter 2 mailles à l'endroit, puis les 2 mailles de l'aiguille auxiliaire. La torsade s'incline à gauche."
      },
      "c4b": {
        translation: "4 m tors. à d.",
        description: "Cable 4 Back: Placer 2 mailles sur l'aiguille auxiliaire DERRIÈRE le travail, tricoter 2 mailles à l'endroit, puis les 2 mailles de l'aiguille auxiliaire. La torsade s'incline à droite."
      },
      "c6f": {
        translation: "6 m tors. à g.",
        description: "Cable 6 Front: Placer 3 mailles sur l'aiguille auxiliaire DEVANT le travail, tricoter 3 mailles à l'endroit, puis les 3 mailles de l'aiguille auxiliaire."
      },
      "c6b": {
        translation: "6 m tors. à d.",
        description: "Cable 6 Back: Placer 3 mailles sur l'aiguille auxiliaire DERRIÈRE le travail, tricoter 3 mailles à l'endroit, puis les 3 mailles de l'aiguille auxiliaire."
      },
      "t3f": {
        translation: "3 m crois. à g.",
        description: "Twist 3 Front: 2 mailles sur l'aiguille auxiliaire devant, 1 envers, puis les 2 mailles à l'endroit."
      },
      "t3b": {
        translation: "3 m crois. à d.",
        description: "Twist 3 Back: 1 maille sur l'aiguille auxiliaire derrière, 2 endroit, puis la maille à l'envers."
      }
    },
    ui: {
      charCount: "caractères",
      row: "Rang",
      rows: "Rangs",
      round: "Tour",
      rounds: "Tours",
      times: "fois",
      stitchK: "end",
      stitchP: "env",
      betaNotice: "[Traduction BETA Bonifaktur - Des erreurs peuvent survenir. Si vous en trouvez, faites-le nous savoir!]",
      videoLink: "Voir le tutoriel vidéo",
      statsText: "termes traduits",
      statsSimple: "simples",
      statsComplex: "techniques complexes",
      copied: "Copié!"
    }
  },

  // ============================================================
  // SPANISH
  // ============================================================
  es: {
    simple: {
      // === BASIC STITCHES ===
      "k": "der",
      "p": "rev",
      "knit": "punto derecho",
      "purl": "punto revés",
      "yo": "lazada",
      "sl": "desl.",
      "slip": "deslizar",
      "st": "p",
      "sts": "p",
      "stitch": "punto",
      "stitches": "puntos",

      // === CAST ON METHODS ===
      "cast on": "montar",
      "co": "montar",
      "long tail cast on": "montaje de cola larga",
      "cable cast on": "montaje de cable",
      "knitted cast on": "montaje tejido",
      "provisional cast on": "montaje provisional",
      "tubular cast on": "montaje tubular",
      "italian cast on": "montaje tubular",
      "judy's magic cast on": "montaje mágico de Judy",
      "jmco": "montaje mágico de Judy",
      "backwards loop cast on": "montaje de bucle hacia atrás",
      "backward loop cast on": "montaje de bucle hacia atrás",
      "german twisted cast on": "montaje alemán torcido",
      "old norwegian cast on": "montaje noruego",
      "crochet cast on": "montaje con ganchillo",
      "emily ocker's cast on": "montaje de Emily Ocker",
      "turkish cast on": "montaje turco",
      "figure 8 cast on": "montaje en ocho",

      // === BIND OFF METHODS ===
      "bind off": "cerrar",
      "bo": "cerrar",
      "cast off": "cerrar",
      "stretchy bind off": "cierre elástico",
      "sewn bind off": "cierre cosido",
      "three needle bind off": "cierre con 3 agujas",
      "3 needle bind off": "cierre con 3 agujas",
      "picot bind off": "cierre picot",
      "i-cord bind off": "cierre i-cord",
      "icord bind off": "cierre i-cord",
      "tubular bind off": "cierre tubular",
      "italian bind off": "cierre tubular",
      "suspended bind off": "cierre suspendido",
      "jeny's surprisingly stretchy bind off": "cierre elástico de Jeny",
      "jssbo": "cierre elástico de Jeny",

      // === ROWS AND ROUNDS ===
      "row": "vuelta",
      "rows": "vueltas",
      "round": "vuelta",
      "rnd": "vta",
      "rounds": "vueltas",
      "rnds": "vtas",
      "rs": "der. lab.",
      "ws": "rev. lab.",
      "right side": "derecho del trabajo",
      "wrong side": "revés del trabajo",
      "in the round": "en circular",
      "worked flat": "tejido plano",
      "back and forth": "ida y vuelta",
      "bor": "inicio de vuelta",
      "beginning of round": "inicio de la vuelta",
      "end of round": "fin de la vuelta",

      // === BASIC INSTRUCTIONS ===
      "repeat": "repetir",
      "rep": "rep.",
      "until": "hasta",
      "from": "desde",
      "to end": "hasta el final",
      "to last": "hasta los últimos",
      "across": "a lo largo de toda la vuelta",
      "work even": "tejer sin aum./dism.",
      "continue": "continuar",
      "continue in pattern": "continuar en patrón",
      "at the same time": "al mismo tiempo",
      "every other row": "cada 2 vueltas",
      "every 4th row": "cada 4 vueltas",
      "times": "veces",
      "times more": "veces más",
      "remaining": "restantes",
      "rem": "rest.",

      // === INCREASES (SIMPLE) ===
      "increase": "aumentar",
      "inc": "aum.",
      "kfb": "der. del. y det.",
      "pfb": "rev. del. y det.",
      "m1": "1 aum.",
      "make one": "aumentar 1 punto",

      // === DECREASES (SIMPLE) ===
      "decrease": "disminuir",
      "dec": "dism.",
      "p2tog": "2 p rev. juntos",
      "p3tog": "3 p rev. juntos",
      "skp": "1 p desl., 1 der., pasar p desl.",
      "psso": "pasar por encima",
      "pass slipped stitch over": "pasar el punto deslizado por encima",

      // === STITCH PATTERNS ===
      "stockinette": "punto jersey",
      "stockinette stitch": "punto jersey",
      "st st": "p. jersey",
      "stocking stitch": "punto jersey",
      "reverse stockinette": "jersey revés",
      "reverse st st": "jersey revés",
      "rev st st": "jersey revés",
      "garter": "punto bobo",
      "garter stitch": "punto bobo",
      "ribbing": "elástico",
      "rib": "elástico",
      "1x1 rib": "elástico 1x1",
      "2x2 rib": "elástico 2x2",
      "seed stitch": "punto arroz",
      "moss stitch": "punto musgo",
      "basketweave": "punto cesta",
      "honeycomb": "punto panal",
      "trinity stitch": "punto trinidad",
      "blackberry stitch": "punto mora",
      "bobble": "bolita",
      "popcorn stitch": "punto popcorn",
      "lace": "calado",
      "eyelet": "ojal decorativo",
      "faggoting": "punto calado",
      "nupps": "nupps",
      "beaded": "con cuentas",

      // === CABLES ===
      "cable": "trenza",
      "cn": "ag. aux.",
      "cable needle": "aguja auxiliar",
      "twist": "cruce",
      "hold in front": "sostener delante",
      "hold in back": "sostener detrás",
      "cross": "cruzar",

      // === COLORWORK ===
      "mc": "CP",
      "main color": "color principal",
      "cc": "CC",
      "contrast color": "color contrastante",
      "color a": "color A",
      "color b": "color B",
      "color c": "color C",
      "stranded": "jacquard",
      "stranded colorwork": "jacquard",
      "fair isle": "Fair Isle",
      "intarsia": "intarsia",
      "mosaic knitting": "tejido mosaico",
      "double knitting": "doble tejido",
      "float": "hilo flotante",
      "catch float": "atrapar hilo flotante",
      "steek": "steek",
      "dominant color": "color dominante",

      // === SHORT ROWS ===
      "short rows": "vueltas cortas",
      "turn": "girar",
      "wrap and turn": "envolver y girar",
      "w&t": "env. y girar",
      "w+t": "env. y girar",
      "pick up wrap": "recoger envoltura",
      "hide wrap": "ocultar envoltura",
      "shadow wrap": "envoltura sombra",
      "twin stitch": "punto gemelo",

      // === NEEDLES ===
      "dpn": "ag. doble punta",
      "dpns": "ag. doble punta",
      "double pointed needles": "agujas de doble punta",
      "circular needle": "aguja circular",
      "circulars": "agujas circulares",
      "straight needles": "agujas rectas",
      "interchangeable": "intercambiables",
      "cable length": "longitud del cable",

      // === TECHNIQUES ===
      "join": "unir",
      "join for working in the round": "unir para tejer en circular",
      "place marker": "colocar marcador",
      "pm": "col. marc.",
      "slip marker": "deslizar marcador",
      "sm": "desl. marc.",
      "marker": "marcador",
      "pick up": "recoger",
      "pick up and knit": "recoger y tejer del derecho",
      "pick up and purl": "recoger y tejer del revés",
      "knitwise": "como para tejer del derecho",
      "purlwise": "como para tejer del revés",
      "tbl": "torcido",
      "through back loop": "por la hebra de atrás",
      "wyib": "hilo detrás",
      "wyif": "hilo delante",
      "with yarn in back": "con hilo detrás",
      "with yarn in front": "con hilo delante",
      "hold": "dejar en espera",
      "place on holder": "poner en guardapuntos",
      "set aside": "apartar",
      "break yarn": "cortar hilo",
      "join yarn": "unir hilo nuevo",

      // === GARMENT PARTS ===
      "sleeve": "manga",
      "sleeves": "mangas",
      "body": "cuerpo",
      "front": "delantero",
      "back": "espalda",
      "cuff": "puño",
      "collar": "cuello",
      "neckline": "escote",
      "neckband": "borde del cuello",
      "yoke": "canesú",
      "raglan": "raglán",
      "saddle shoulder": "hombro de silla",
      "set-in sleeve": "manga montada",
      "armhole": "sisa",
      "shoulder": "hombro",
      "shoulders": "hombros",
      "hem": "dobladillo",
      "buttonhole": "ojal",
      "buttonband": "tapeta de botones",
      "waist shaping": "forma de cintura",
      "bust darts": "pinzas de busto",

      // === SOCK PARTS ===
      "heel": "talón",
      "heel flap": "solapa del talón",
      "heel turn": "vuelta del talón",
      "gusset": "cuña",
      "toe": "punta",
      "instep": "empeine",
      "sole": "planta",
      "leg": "caña",
      "top down": "de arriba abajo",
      "toe up": "de punta hacia arriba",
      "cuff down": "del puño hacia abajo",
      "two at a time": "dos a la vez",
      "taat": "dos a la vez",
      "short row heel": "talón de vueltas cortas",
      "afterthought heel": "talón posterior",

      // === FINISHING ===
      "seam": "costura",
      "seaming": "coser",
      "weave in ends": "esconder cabos",
      "block": "bloquear",
      "blocking": "bloqueo",
      "wet blocking": "bloqueo húmedo",
      "steam blocking": "bloqueo al vapor",
      "pin": "sujetar con alfileres",
      "blocking mats": "alfombras de bloqueo",
      "blocking wires": "alambres de bloqueo",
      "finishing": "acabado",
      "grafting": "injerto",

      // === CONSTRUCTION ===
      "seamless": "sin costuras",
      "seamed": "con costuras",
      "bottom up": "de abajo arriba",
      "piece": "pieza",
      "beginning": "inicio",
      "beg": "inic.",
      "end": "fin",
      "all": "todos",
      "work": "tejer",
      "measures": "mide",
      "pattern": "patrón",

      // === GAUGE ===
      "gauge": "muestra",
      "gauge swatch": "muestra de tensión",
      "swatch": "muestra",
      "stitches per inch": "puntos por pulgada",
      "rows per inch": "vueltas por pulgada",

      // === YARN ===
      "yarn": "hilo",
      "skein": "madeja",
      "ball": "ovillo",
      "hank": "madeja",
      "yardage": "metraje",
      "fingering": "fingering",
      "sport": "sport",
      "dk": "DK",
      "worsted": "worsted",
      "bulky": "grueso",
      "super bulky": "super grueso",

      // === MEASUREMENTS ===
      "cm": "cm",
      "inches": "pulgadas",
      "inch": "pulgada"
    },
    complex: {
      // === DECREASES ===
      "k2tog": {
        translation: "2 p der. juntos",
        description: "Tejer 2 puntos juntos del derecho: Insertar la aguja en los 2 puntos siguientes de izquierda a derecha y tejerlos juntos como uno solo. Resulta una disminución inclinada a la derecha."
      },
      "k3tog": {
        translation: "3 p der. juntos",
        description: "Tejer 3 puntos juntos del derecho: Insertar la aguja en los 3 puntos siguientes y tejerlos juntos como uno solo. Resulta una doble disminución inclinada a la derecha."
      },
      "ssk": {
        translation: "2 p der. torc. juntos",
        description: "Deslizar 2 puntos uno por uno como para tejerlos del derecho, luego tejerlos juntos por la hebra de atrás. Resulta una disminución inclinada a la izquierda."
      },
      "sssk": {
        translation: "3 p der. torc. juntos",
        description: "Deslizar 3 puntos uno por uno como para tejerlos del derecho, luego tejerlos juntos por la hebra de atrás. Resulta una doble disminución inclinada a la izquierda."
      },
      "sk2p": {
        translation: "1 p desl., 2 p der. juntos, pasar",
        description: "Doble disminución centrada: Deslizar 1 punto, tejer 2 puntos juntos del derecho, pasar el punto deslizado por encima. Resulta 2 disminuciones con inclinación centrada."
      },
      "s2kp": {
        translation: "2 p desl., 1 der., pasar 2 p",
        description: "Doble disminución centrada: Deslizar 2 puntos juntos, tejer 1 punto del derecho, pasar los 2 puntos deslizados por encima."
      },
      "cdd": {
        translation: "dism. doble centr.",
        description: "Central Double Decrease / Disminución doble centrada: Deslizar 2 puntos juntos como para tejerlos del derecho, tejer 1 punto del derecho, pasar los 2 puntos deslizados."
      },
      "sl1-k1-psso": {
        translation: "1 p desl., 1 der., pasar",
        description: "Deslizar 1 punto, tejer 1 punto del derecho, pasar el punto deslizado por encima. Resulta una disminución inclinada a la izquierda."
      },

      // === INCREASES ===
      "kfbf": {
        translation: "der.-del.-det.-del.",
        description: "Triple aumento de un punto: Tejer del derecho en la hebra delantera, luego en la trasera, luego de nuevo en la delantera. De 1 punto salen 3."
      },
      "m1l": {
        translation: "1 aum. a izq.",
        description: "Aumento inclinado a la izquierda: Levantar la hebra entre los puntos por delante con la aguja izquierda y tejerla del derecho torcido."
      },
      "m1r": {
        translation: "1 aum. a der.",
        description: "Aumento inclinado a la derecha: Levantar la hebra entre los puntos por detrás con la aguja izquierda y tejerla del derecho torcido."
      },
      "m1p": {
        translation: "1 aum. rev.",
        description: "Aumentar 1 punto del revés: Levantar la hebra entre los puntos y tejerla del revés."
      },
      "kll": {
        translation: "aum. levant. izq.",
        description: "Aumento levantado izquierdo: Levantar el bucle izquierdo del punto de la vuelta anterior y tejerlo del derecho."
      },
      "krl": {
        translation: "aum. levant. der.",
        description: "Aumento levantado derecho: Levantar el bucle derecho del punto de la vuelta anterior y tejerlo del derecho."
      },
      "lifted increase": {
        translation: "aumento levantado",
        description: "Un aumento donde se levanta el bucle del punto de la vuelta anterior y se teje. Casi invisible."
      },

      // === SLIP STITCHES ===
      "sl1": {
        translation: "1 p desl.",
        description: "Deslizar 1 punto: Pasar el punto de la aguja izquierda a la derecha sin tejerlo (como para tejerlo del revés si no se indica lo contrario)."
      },
      "sl1 wyif": {
        translation: "1 p desl. hilo del.",
        description: "Deslizar 1 punto con el hilo delante del trabajo."
      },
      "sl1 wyib": {
        translation: "1 p desl. hilo det.",
        description: "Deslizar 1 punto con el hilo detrás del trabajo."
      },

      // === TECHNIQUES ===
      "kitchener stitch": {
        translation: "punto kitchener",
        description: "Técnica para unir invisiblemente dos filas de puntos abiertos con una aguja lanera. El resultado parece una vuelta tejida. Se usa frecuentemente para las puntas de calcetines."
      },
      "mattress stitch": {
        translation: "punto colchonero",
        description: "Técnica para coser casi invisiblemente las piezas tejidas a lo largo de los bordes laterales. El hilo pasa entre los puntos de orilla."
      },
      "lifeline": {
        translation: "hilo de seguridad",
        description: "Un hilo de seguridad pasado a través de todos los puntos de una vuelta. En caso de error se puede volver fácilmente a este punto."
      },
      "magic loop": {
        translation: "magic loop",
        description: "Técnica para tejer circunferencias pequeñas (calcetines, mangas, gorros) con una aguja circular larga (80-100 cm). El cable se saca por la mitad."
      },
      "german short rows": {
        translation: "vueltas cortas alemanas",
        description: "Técnica de vueltas cortas sin envolturas. En su lugar se forma un punto doble (punto gemelo). Muy discreto en el tejido terminado."
      },
      "japanese short rows": {
        translation: "vueltas cortas japonesas",
        description: "Técnica de vueltas cortas usando imperdibles o marcadores para señalar los puntos de giro."
      },
      "wrap and turn": {
        translation: "envolver y girar",
        description: "Técnica estándar para vueltas cortas: El siguiente punto se envuelve, luego se gira el trabajo. Al volver la envoltura se teje junto con el punto."
      },

      // === STITCH PATTERNS ===
      "fisherman's rib": {
        translation: "punto inglés",
        description: "Un punto elástico particularmente elástico, grueso y cálido. Se hace tejiendo en el punto de la vuelta anterior."
      },
      "brioche": {
        translation: "brioche",
        description: "Punto suave y elástico, monocolor o bicolor. Caracterizado por los puntos con lazada y el aspecto reversible."
      },
      "i-cord": {
        translation: "i-cord",
        description: "Un cordón tubular estrecho hecho con agujas de doble punta o dos agujas. Versátil para asas, trabillas y decoraciones."
      },

      // === CAST ON TECHNIQUES ===
      "tubular cast on": {
        translation: "montaje tubular",
        description: "Un montaje elástico y redondeado para bordes acanalados, de aspecto profesional. Comienza con hilo auxiliar y lazadas."
      },
      "judy's magic cast on": {
        translation: "montaje mágico de Judy",
        description: "Montaje perfecto para calcetines toe-up. Crea una punta cerrada sin costura. Inventado por Judy Becker."
      },

      // === COLORWORK ===
      "jogless join": {
        translation: "unión sin escalón",
        description: "Técnica para unir invisiblemente las vueltas al tejer con cambio de color. Evita el visible 'efecto escalera' al inicio de la vuelta."
      },
      "steek": {
        translation: "steek",
        description: "Técnica del Fair Isle: Se tejen puntos extra que luego se cortan para crear aberturas para mangas o escotes."
      },
      "stranded colorwork": {
        translation: "jacquard",
        description: "Técnica de tejido con varios colores por vuelta. Los hilos no usados se llevan por detrás (hilos flotantes)."
      },

      // === CABLES ===
      "cable": {
        translation: "trenza",
        description: "Los puntos se cruzan en un orden específico para crear un patrón de trenza. Requiere normalmente una aguja auxiliar."
      },
      "c4f": {
        translation: "4 p trenz. a izq.",
        description: "Cable 4 Front: Poner 2 puntos en la aguja auxiliar DELANTE del trabajo, tejer 2 puntos del derecho, luego los 2 puntos de la aguja auxiliar. La trenza se inclina a la izquierda."
      },
      "c4b": {
        translation: "4 p trenz. a der.",
        description: "Cable 4 Back: Poner 2 puntos en la aguja auxiliar DETRÁS del trabajo, tejer 2 puntos del derecho, luego los 2 puntos de la aguja auxiliar. La trenza se inclina a la derecha."
      },
      "c6f": {
        translation: "6 p trenz. a izq.",
        description: "Cable 6 Front: Poner 3 puntos en la aguja auxiliar DELANTE del trabajo, tejer 3 puntos del derecho, luego los 3 puntos de la aguja auxiliar."
      },
      "c6b": {
        translation: "6 p trenz. a der.",
        description: "Cable 6 Back: Poner 3 puntos en la aguja auxiliar DETRÁS del trabajo, tejer 3 puntos del derecho, luego los 3 puntos de la aguja auxiliar."
      },
      "t3f": {
        translation: "3 p cruce a izq.",
        description: "Twist 3 Front: 2 puntos en la aguja auxiliar delante, 1 revés, luego los 2 puntos del derecho."
      },
      "t3b": {
        translation: "3 p cruce a der.",
        description: "Twist 3 Back: 1 punto en la aguja auxiliar detrás, 2 derecho, luego el punto del revés."
      }
    },
    ui: {
      charCount: "caracteres",
      row: "Vuelta",
      rows: "Vueltas",
      round: "Vuelta",
      rounds: "Vueltas",
      times: "veces",
      stitchK: "der",
      stitchP: "rev",
      betaNotice: "[Traducción BETA de Bonifaktur - Pueden haber errores. ¡Si encuentras alguno, háznoslo saber!]",
      videoLink: "Ver video tutorial",
      statsText: "términos traducidos",
      statsSimple: "simples",
      statsComplex: "técnicas complejas",
      copied: "¡Copiado!"
    }
  }
};

// For backwards compatibility, set default dictionaries to German
window.simpleDict = window.translatorDicts.de.simple;
window.complexDict = window.translatorDicts.de.complex;
